<template>
  <div class="sku_stepper">
    <button @click="minus" :disabled="minusDisabled" class="stepper_minus"></button>
    <input :disabled="disabled" @blur="change" :value="number" type="tel" class="stepper_input">
    <button @click="plus" :disabled="plusDisabled" class="stepper_plus"></button>
  </div>
</template>
<script>
export default {
  props: {
    number: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    minusDisabled: function() {
      return this.disabled || this.number <= this.min;
    },
    plusDisabled: function() {
      return this.disabled || this.number >= this.max;
    }
  },
  data() {
    return {};
  },
  methods: {
    change(evt) {
      let value = evt.target.value || 1;

      if (!/^[0-9]*$/.test(value)) {
        Vue.$wheatToast({
          message: '请输入正整数',
          position: "middle"
        });
        return false;
      }
      if (value > this.max) {
        value = this.max;
      } else if (value < this.min) {
        value = this.min;
      }
      this.$emit('change', { type: 'change', value });
      this.$forceUpdate();
    },
    minus() {
      const value = this.number * 1 - 1;

      this.$emit('change', { type: 'minus', value });
    },
    plus() {
      const value = this.number * 1 + 1;

      this.$emit('change', { type: 'plus', value });
    }
  }
}
</script>
<style lang="less">
.sku_stepper {
  .stepper_minus, .stepper_plus {
    position: relative;
    box-sizing: border-box;
    width: 0.7rem;
    height: 0.66rem;
    margin: 0;
    padding: 0;
    color: #323233;
    vertical-align: middle;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }
  .stepper_minus[disabled], .stepper_plus[disabled] {
    color: #c8c9cc;
  }
  .stepper_minus::before, .stepper_plus::before, .stepper_plus::after {
    width: 50%;
    height: 1px;
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: currentColor;
    transform: translate(-50%,-50%);
    content: "";
  }
  .stepper_plus::after {
    width: 1px;
    height: 50%;
  }
  .stepper_minus {
    margin-right: -0.1rem;
    border-radius: 0.1rem 0 0 0.1rem;
  }
  .stepper_plus {
    margin-left: -0.1rem;
    border-radius: 0 0.1rem 0.1rem 0;
  }
  .stepper_input {
    box-sizing: border-box;
    width: 1.2rem;
    height: 0.66rem;
    margin: 0;
    padding: 0;
    color: #323233;
    font-size: 0.3rem;
    line-height: normal;
    text-align: center;
    vertical-align: middle;
    border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    border-radius: 0;
    -webkit-appearance: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Stepper.vue